import { SpaceApi } from "../platform_spaces/space/SpaceApi";
import { mergeModulesWithSubscriptions } from "../platform_spaces/space/SpaceModel";
import type { MembershipProduct, SpaceProfile } from "../platform_spaces/space/SpaceType";

export async function resolveMembershipProductForOrder(
  spaceId: string,
  spaceProductId: string
): Promise<MembershipProduct | null> {
  const sid = spaceId.trim();
  const pid = spaceProductId.trim();
  if (!sid || !pid) {
    return null;
  }
  const [modulesRes, subsRes] = await Promise.all([
    SpaceApi.getStartupConfig(sid),
    SpaceApi.getSubscriptionDetail(sid),
  ]);
  if (typeof modulesRes === "string" || !Array.isArray(modulesRes)) {
    return null;
  }
  const subs =
    typeof subsRes === "string" || subsRes == null ? null : subsRes.items ?? null;
  const products = mergeModulesWithSubscriptions(modulesRes, subs);
  return products.find((p) => p.spaceProductId === pid) ?? null;
}

export async function resolveSpaceProfileForOrder(spaceId: string): Promise<SpaceProfile | null> {
  const sid = spaceId.trim();
  if (!sid) {
    return null;
  }
  return SpaceApi.getSpaceProfile(sid);
}
